function Token({
    color,
    position,
    onClick,
    canMove,
    isCurrentPlayer,
}) {

    if (!position) {
        return null;
    }


    return (
        <div
            className={`
                ludo-token
                ${color}
                ${canMove
                    ? "token-can-move"
                    : ""}
                ${isCurrentPlayer
                    ? "current-player-token"
                    : ""}
            `}
            style={{
                left: position.left,
                top: position.top,

                // Current player's token
                // always comes above others
                zIndex:
                    isCurrentPlayer
                        ? 100
                        : 20,
            }}
            onClick={onClick}
        >

            <div className="token-inner">

                <div className="token-highlight"></div>

            </div>

        </div>
    );
}

export default Token;